/* wm-shine: progressive enhancement only. Without it every page still reads and works. */
(function () {
  var doc = document.documentElement;
  doc.classList.add('wm-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Header height feeds the sticky offsets. */
  var bar = document.querySelector('.wm-header-bar');
  function setHeader() { if (bar) { doc.style.setProperty('--wm-header-h', bar.getBoundingClientRect().height + 'px'); } }
  setHeader();
  window.addEventListener('resize', setHeader, { passive: true });

  var svg = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var LEFT = 'M15 18l-6-6 6-6', RIGHT = 'M9 6l6 6-6 6', CLOSE = 'M6 6l12 12M18 6L6 18';

  /* ---------- Shelf controls ---------- */
  document.querySelectorAll('.pf-row').forEach(function (row, i) {
    var shelf = row.closest('.pf-shelf, .wm-start');
    var title = shelf && shelf.querySelector('h2');
    row.setAttribute('tabindex', '0');
    row.setAttribute('role', 'region');
    row.setAttribute('aria-label', (title ? title.textContent.trim() : 'Projects') + ', scrollable');
    var ctl = document.createElement('div');
    ctl.className = 'wm-shelf-ctl';
    ctl.innerHTML = '<button type="button" class="wm-shelf-btn" data-dir="-1" aria-label="Previous projects">' + svg(LEFT) + '</button>' +
                    '<button type="button" class="wm-shelf-btn" data-dir="1" aria-label="Next projects">' + svg(RIGHT) + '</button>';
    row.insertAdjacentElement('afterend', ctl);
    var prev = ctl.children[0], next = ctl.children[1];
    function step() {
      var card = row.firstElementChild;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 24;
      var w = card ? card.getBoundingClientRect().width + gap : row.clientWidth * .8;
      return Math.max(w, Math.floor(row.clientWidth / w) * w);
    }
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      ctl.hidden = max <= 2;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max - 2;
    }
    ctl.addEventListener('click', function (e) {
      var b = e.target.closest('.wm-shelf-btn');
      if (!b || b.disabled) { return; }
      row.scrollBy({ left: step() * Number(b.dataset.dir), behavior: reduce.matches ? 'auto' : 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  /* ---------- Sticky in-page navigation: mark the section in view ---------- */
  document.querySelectorAll('.wm-localnav, .pf-jumps').forEach(function (nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) { return document.getElementById(decodeURIComponent(a.hash.slice(1))); });
    if (!('IntersectionObserver' in window) || !targets.some(Boolean)) { return; }
    var seen = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      var current = null;
      targets.forEach(function (t, i) { if (t && seen.get(t) && current === null) { current = i; } });
      if (current === null) { return; }
      links.forEach(function (a, i) {
        if (i === current) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); }
      });
      var on = links[current];
      if (on && nav.scrollWidth > nav.clientWidth) {
        var box = on.closest('.wm-localnav-in') || nav;
        var l = on.offsetLeft - box.clientWidth / 2 + on.clientWidth / 2;
        box.scrollTo({ left: Math.max(0, l), behavior: 'auto' });
      }
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
    targets.forEach(function (t) { if (t) { io.observe(t); } });
  });

  /* ---------- Image zoom: case images open in a native modal dialog ---------- */
  var imgs = Array.prototype.slice.call(document.querySelectorAll('.ap-case .ap-hero-media img, .ap-case .ap-ch-media img, .ap-case .ap-detail-grid img'));
  if (imgs.length && typeof HTMLDialogElement === 'function') {
    var dlg = document.createElement('dialog');
    dlg.className = 'wm-lightbox';
    dlg.setAttribute('aria-label', 'Enlarged image');
    dlg.innerHTML = '<div class="wm-lightbox-bar"><span class="wm-lightbox-count" aria-live="polite"></span>' +
      '<button type="button" class="wm-lightbox-close" aria-label="Close">' + svg(CLOSE) + '</button></div>' +
      '<div class="wm-lightbox-stage"><img alt=""></div><p class="wm-lightbox-cap"></p>' +
      '<button type="button" class="wm-lightbox-prev" aria-label="Previous image">' + svg(LEFT) + '</button>' +
      '<button type="button" class="wm-lightbox-next" aria-label="Next image">' + svg(RIGHT) + '</button>';
    document.body.appendChild(dlg);
    var big = dlg.querySelector('.wm-lightbox-stage img'), cap = dlg.querySelector('.wm-lightbox-cap'), count = dlg.querySelector('.wm-lightbox-count');
    var at = 0, opener = null;
    dlg.addEventListener('close', function () { if (opener) { opener.focus({ preventScroll: true }); } });
    function show(i) {
      at = (i + imgs.length) % imgs.length;
      var src = imgs[at];
      big.src = src.currentSrc || src.src;
      big.alt = src.alt || '';
      var fig = src.closest('figure');
      var fc = fig && fig.querySelector('figcaption');
      cap.textContent = fc ? fc.textContent : (src.alt || '');
      count.textContent = (at + 1) + ' of ' + imgs.length;
    }
    imgs.forEach(function (img, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wm-zoom';
      btn.setAttribute('aria-label', 'Enlarge image' + (img.alt ? ': ' + img.alt : ''));
      img.parentNode.insertBefore(btn, img);
      btn.appendChild(img);
      btn.addEventListener('click', function () { opener = btn; show(i); dlg.showModal(); });
    });
    dlg.querySelector('.wm-lightbox-close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.wm-lightbox-prev').addEventListener('click', function () { show(at - 1); });
    dlg.querySelector('.wm-lightbox-next').addEventListener('click', function () { show(at + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('wm-lightbox-stage')) { dlg.close(); } });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(at - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(at + 1); e.preventDefault(); }
    });
    if (imgs.length < 2) { dlg.querySelector('.wm-lightbox-prev').hidden = true; dlg.querySelector('.wm-lightbox-next').hidden = true; }
  }
})();

/* Cinematic hero film: plays muted only when motion and data allow; pauses off screen; visible pause control. */
(function () {
  var v = document.querySelector('.wm-cine__video');
  if (!v) { return; }
  var btn = document.querySelector('.wm-cine__toggle');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var save = navigator.connection && navigator.connection.saveData;
  if (reduce.matches || save) { return; }
  var small = window.matchMedia('(max-width: 760px)').matches;
  /* Rotate the reel pool per visit: first visit plays the first reel, then each visit plays the next.
     The inline script after the hero normally picks before first paint and sets data-reel; this is the fallback. */
  var host = v.closest('[data-reels]'), pool = [];
  try { pool = JSON.parse(host.getAttribute('data-reels')) || []; } catch (e) { pool = []; }
  if (pool.length > 1 && !host.hasAttribute('data-reel')) {
    var idx = 0;
    try { var last = window.localStorage.getItem('wm-reel'); idx = last === null ? 0 : (parseInt(last, 10) + 1) % pool.length; window.localStorage.setItem('wm-reel', String(idx)); } catch (e) { idx = 0; }
    var r = pool[idx] || pool[0];
    v.poster = r.poster; v.dataset.srcLg = r.lg; v.dataset.srcSm = r.sm;
    var credit = document.querySelector('.wm-cine__credit');
    if (credit && r.credit) { credit.innerHTML = r.credit; }
    host.setAttribute('data-reel', r.id || String(idx));
  }
  v.src = small ? v.dataset.srcSm : v.dataset.srcLg;
  v.preload = 'auto';
  var userPaused = false;
  function setBtn(paused) {
    if (!btn) { return; }
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
  }
  function play() { var p = v.play(); if (p && p.catch) { p.catch(function () { setBtn(true); }); } setBtn(false); }
  if (btn) {
    btn.hidden = false;
    btn.addEventListener('click', function () {
      if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); setBtn(true); }
    });
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { if (!userPaused) { play(); } } else { v.pause(); } });
    }, { threshold: .15 }).observe(v);
  } else { play(); }
  reduce.addEventListener('change', function () { if (reduce.matches) { v.pause(); setBtn(true); userPaused = true; } });
})();
